import {
  Box,
  Editable, EditablePreview, EditableTextarea, Grid, GridItem, Heading, Text, useStyleConfig,
} from '@chakra-ui/react';
import React from 'react';
import { addNote, saveNotes } from './utils';
import EditableNote from './EditableNote';
import ClearableNote from './ClearableNote';
import EditableReply from './EditableReply';
import { MdAddBox, MdOutlineQuickreply } from 'react-icons/md';
import { RiDeleteBinLine } from 'react-icons/ri';
import Key from './Key';

const Notes = ({props, notesUtils }) => {
  const variant = 'wrapper';
  const noteStyles = useStyleConfig('Notes', { variant });
  return props.stateProps.isAdmin ? (
   <Box sx={{...noteStyles}}>
      {notesUtils.notes !== undefined && (
        Object.values(notesUtils.notes).map((note,noteOrder) => {
            return (
              <Box   margin= '0 .5rem 1rem .5rem' >

                <EditableNote note={note} noteOrder={noteOrder} notesUtils={notesUtils} noteStyles={noteStyles} />
                <Box className="replyWrapper">
                  {note.replies !== undefined && (
                    Object.values(note.replies).map((reply, replyOrder) => {
                        return (
                          <EditableReply reply={reply} noteOrder={noteOrder} replyOrder={replyOrder} notesUtils={notesUtils} noteStyles = {noteStyles} />
                        );
                      },
                    )
                  )
                  }</Box>
              </Box>
            );
          },
        )
      )
      }
       <Key props={props} notesUtils={notesUtils}/>
    </Box>
  ) : (
    <Box sx={{...noteStyles}}>
      {notesUtils.notes !== undefined && (
        Object.values(notesUtils.notes).map((note,noteOrder) => {
            return (
              <Box
                    padding=".5rem" marginBottom='1rem'>
                <Text>{note.title}</Text>
              <ClearableNote note={note} noteOrder={noteOrder} notesUtils={notesUtils} />
                {note.replies !== undefined && (
                  Object.values(note.replies).map((reply,replyOrder) => {
                  return (
                    <EditableReply reply={reply} noteOrder={noteOrder} replyOrder={replyOrder} notesUtils={notesUtils} noteStyles = {noteStyles} />
                    );
                  },
                )
                )
                  }
              </Box>
            );
          },
        )
      )
      }
      <Key props={props} notesUtils={notesUtils}/>
    </Box>
    );
    };
export default Notes;